export default {"src":"/_next/static/media/ems.3bf3ba51.svg","height":48,"width":465,"blurWidth":0,"blurHeight":0};